import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { caseActions } from '../../state/case/case.actions'
import { selectionActions } from '../../state/selection/selection.actions'
import { SegObjectPropertyMap, CaseId } from '../../state/case/case.state'
import {
    selectCaseSegObjectPropertyMap,
    selectHasSegObjectPropertyMaps,
    selectCaseSegObjectPropertyMaps,
    selectCaseId,
} from '../../state/case/case.selectors'

@Component({
    selector: 'app-segobjectpropertymap-panel',
    templateUrl: './segobjectpropertymap-panel.component.html',
    styleUrls: ['./segobjectpropertymap-panel.component.scss'],
})
export class SegObjectPropertyMapPanelComponent {
    readonly hasSegObjectPropertyMaps$ = this.store.select(selectHasSegObjectPropertyMaps)
    readonly segObjectPropertyMaps$ = this.store.select(selectCaseSegObjectPropertyMaps)
    readonly selectedSegObjectPropertyMap$ = this.store.select(selectCaseSegObjectPropertyMap)
    constructor(private readonly store: Store) {}

    setSegObjectPropertyMap(segObjectPropertyMap: SegObjectPropertyMap): void {
        this.store.select(selectCaseId).subscribe((caseId: CaseId) => {
            this.store.dispatch(selectionActions.clearSelection())
            this.store.dispatch(
                caseActions.selectSegObjectPropertyMap({
                    segobjectpropertymap: segObjectPropertyMap,
                })
            )
            this.store.dispatch(
                caseActions.loadSegObjectPropertiesData({
                    caseId: caseId,
                    segobjectpropertymap: segObjectPropertyMap,
                })
            )
            this.store.dispatch(
                selectionActions.setFreeSelectionSegSource({
                    segSource: segObjectPropertyMap.segSource,
                })
            )
            this.store.dispatch(
                selectionActions.setHierarchicalSelectionRootSegSource({
                    segSource: segObjectPropertyMap.segSource,
                })
            )
            this.store.dispatch(
                selectionActions.setAutoCellTypeDetectionRootSegSource({
                    segSource: segObjectPropertyMap.segSource,
                })
            )
        })
    }
}
